import React, { useCallback } from 'react';
import restClient from 'Shared/hooks/restClient';
import _ from 'lodash';
import './LiquidValidator.scoped.scss';

interface LiquidValidatorProps {
    value: string;
    lineSplitTags?: boolean;
    availableTags?: null | { [key: string]: { slug: string; label: string }[] };
    className?: string;
}

const LiquidValidator: React.FC<LiquidValidatorProps>  = ({ value, lineSplitTags = false, availableTags = null, className = '' }) => {
    const [validatingValue, setValidatingValue] = useState("");
    const [hasError, setHasError] = useState(false)
    const [errorHeader, setErrorHeader] = useState('There is an error with your merge tags or conditional logic:')
    const [errorMessage, setErrorMessage] = useState('')

    const debounce = useCallback(
        _.debounce((val) => {
            if (lineSplitTags && val) {
                setValidatingValue(val.split('</p>').join('\n').trim('\n'))
            } else {
                setValidatingValue(val)
            }
        }, 1000), []
    );
    
    const tagsToVariables = (tags: { [key: string]: { slug: string; label: string }[] } | null) => {
        if (!tags) return {};
        return Object.values(tags).flat().reduce((acc, { slug, label }) => {
            slug.split('.').reduce((obj, part, i, arr) => 
                i === arr.length - 1 ? (obj[part] = label) : (obj[part] = obj[part] || {}), acc);
            return acc;
        }, {} as { [key: string]: any });
    };
    
    useEffect(() => debounce(value), [value, lineSplitTags]);
    
    useEffect(() => {
        if (!validatingValue) return;
        restClient.post('/api/render/validate_liquid', {
            body: validatingValue,
            context: tagsToVariables(availableTags),
        }).then((response) => {
            if (response.status === 200) {
                setHasError(false);
                setErrorMessage('');
            } else {
                setHasError(true);
                setErrorHeader('There is an error with your merge tags or conditional logic:');
                setErrorMessage(response.data.error || 'An error occurred while validating the liquid code.');
            }
        }).catch((error) => {
            if (error.response && error.response.status === 422) {
                setHasError(true);
                setErrorHeader('There is an error with your merge tags or conditional logic:');
                setErrorMessage(error.response.data.error || 'An error occurred while validating the liquid code.');
                return;
            }
            setHasError(true);
            setErrorHeader('There was an error while validating:');
            setErrorMessage(error.response.data.error || error.message || 'An error occurred while validating the liquid code.');
        })
    }, [validatingValue])
    
    if (hasError) {
        return (
            <div className={`liquid-validator-error ${className}`}>
                <div>{errorHeader}</div>
                <div className="liquid-validator-error-message">{errorMessage}</div>
            </div>
        )
    }
    return <></>
}

export default LiquidValidator
